import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { EnhancedDropDownRHFWithLabel, ITest, LabelPosition, RHookFormNumberField, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { formatAmountCommaSeperator } from "../../../common/Common";

interface IDeterminingGrossIncomeSetupFieldsPanel {
  profileAppliesFromPayPeriodDDL: IDropDownListResponse[];
  SalaryProfileRecord: any
  id: any,
  wsibCodeDDL: any,
  onProfileAppliesFromPayPeriodChangeHandler: (selected: any) => void;
  employeeDDL: any;
  updatedSalaryProfileDDL: any;
  employeeStatus: any;
  formMethods: any;
  selectedResourceSlip: any;
  onEmployeeSelectionChangeHandler: (selected: any) => void;
  onSalaryProfileSelectionChangeHandler: (selected: any) => void;
  onEmployeeTypeSelectionChangeHandler: (selected: any) => void;
}
export const DeterminingGrossIncomeSetupFieldsPanel: FC<
  IDeterminingGrossIncomeSetupFieldsPanel
> = ({ profileAppliesFromPayPeriodDDL, SalaryProfileRecord, id, wsibCodeDDL, onProfileAppliesFromPayPeriodChangeHandler, employeeDDL, updatedSalaryProfileDDL, employeeStatus, formMethods, selectedResourceSlip,
  onEmployeeSelectionChangeHandler, onSalaryProfileSelectionChangeHandler, onEmployeeTypeSelectionChangeHandler
}) => {
    // RESPONSIVE
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
    const [regularSalaryAndPayRateDisabled, setRegularSalaryAndPayRateDisabled] = useState(200)
    const [grossRemuneration, setGrossRemuneration] = useState(0)
    const onHowIsTheEmployeePaidChangeHandler = (event: any) => {
      setRegularSalaryAndPayRateDisabled(event.value)
    }

    const onRegularSalaryForThePeriodChangeHandler = (e: any) => {
      setGrossRemuneration(e.target.value)
    }
    console.log('SalaryProfileRecord5467567', SalaryProfileRecord)
    useEffect(() => {
      if (SalaryProfileRecord && SalaryProfileRecord.howIsEmployPaid) {
        setRegularSalaryAndPayRateDisabled(SalaryProfileRecord.howIsEmployPaid)
      } else {
        setRegularSalaryAndPayRateDisabled(200)
      }
      if (SalaryProfileRecord && SalaryProfileRecord.regularSalaryForThePeriod) {
        setGrossRemuneration(SalaryProfileRecord.regularSalaryForThePeriod)
      }
    }, [SalaryProfileRecord])

    useEffect(() => {
      if (SalaryProfileRecord) {
        formMethods.setValue('profile', SalaryProfileRecord.id)
      }

    }, [SalaryProfileRecord])
    return (
      <>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          {mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
            label="Select Employee Type"
            selectName="employeeType"
            testId={`employee-type`}
            items={[
              {
                label: "List All Employees",
                value: "all",
              },
              {
                label: "List Active Employees Only",
                value: 100,
              },
              {
                label: "List Inactive Employees Only",
                value: 200,
              },
              {
                label: "List Terminated Employees Only",
                value: 300,
              },
              {
                label: "List Died Employees Only",
                value: 400,
              },
            ]}
            selectedItem={employeeStatus}
            onSelectionChangeHandler={
              onEmployeeTypeSelectionChangeHandler
            }
          />}
          {mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
            label="Load Employee"
            selectName="employee"
            testId={`employee`}
            labelPosition={LabelPosition.Top}
            items={employeeDDL ?? []}
            onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
            showEmpty
          />}
          {mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
            label="Load Profile"
            selectName="profile"
            testId={`profile`}
            labelPosition={LabelPosition.Top}
            items={updatedSalaryProfileDDL ?? []}
            onSelectionChangeHandler={onSalaryProfileSelectionChangeHandler}
            selectedItem={selectedResourceSlip}
            showEmpty
          />}
          <EnhancedDropDownRHFWithLabel
            label="Profile applies from Pay Period"
            labelPosition={LabelPosition.Top}
            selectName="profileAppliesFromPayPeriod"
            testId={`profileAppliesFromPayPeriod`}
            items={profileAppliesFromPayPeriodDDL ?? []}
            showEmpty
            onSelectionChangeHandler={onProfileAppliesFromPayPeriodChangeHandler}
          />
          <EnhancedDropDownRHFWithLabel
            label="How is the employee paid"
            labelPosition={LabelPosition.Top}
            selectName="howIsEmployPaid"
            testId={`howIsEmployPaid`}
            items={[
              { label: "Fixed Salary", value: 200 },
              { label: "By Hours", value: 100 }
            ]}
            selectedItem={200}
            onSelectionChangeHandler={onHowIsTheEmployeePaidChangeHandler}
          />
          <RHookFormNumberFieldWithLabel id={"regularSalaryForThePeriod"} testId={"Regular-Salary-for-the-Period"} label={"Regular Salary for the Period"} readOnly={regularSalaryAndPayRateDisabled === 100 ? true : false} onChangeHandler={onRegularSalaryForThePeriodChangeHandler} />
          <RHookFormNumberFieldWithLabel id={"hourlyRate"} testId={"Hourly-Pay-Rate"} label={"Hourly Pay Rate"} readOnly={regularSalaryAndPayRateDisabled === 200 ? true : false} />
          <RHookFormNumberFieldWithLabel id={"regularHours"} testId={"Regular-Hours"} label={"Regular Hours"} />
          <Grid
            container
            sx={{
              display: "flex",
              mb: "2.1rem",
            }}
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
              sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", fontWeight: "bold" }}
            >
              Gross Remuneration
            </Grid>

            <Grid
              size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
              sx={{ textAlign: "right", fontSize: ".875rem" }}
            >
              <span style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", fontWeight: "bold" }}>{formatAmountCommaSeperator(id && grossRemuneration ? grossRemuneration : 0)}</span>
            </Grid>
          </Grid>
          <RHookFormNumberFieldWithLabel id={"minVocationPayOfGross"} testId={"Min.-Vacation-Pay-%-of-Gross"} label={"Min. Vacation Pay % of Gross"} defaultValue={4} />
          <EnhancedDropDownRHFWithLabel
            label="WSIB Code"
            labelPosition={LabelPosition.Top}
            selectName="wsibCode"
            testId={`wsibCode`}
            items={wsibCodeDDL ?? []}
            selectedItem={100}
          />
        </Grid>
      </>
    );
  };
